/** Checklist gestión documental (conexiones complejas) — alineado con back/src/proyectos/gestion-documental.catalog.ts */
export const GESTION_DOCUMENTAL_ITEMS = [
  {
    tipo: "gestion_doc_carta_remisoria",
    label:
      "Carta remisoria dirigida al Jefe de la Unidad de Proyectos Media Tensión – Gerencia de Energía EMCALI",
    item: 1,
  },
  {
    tipo: "gestion_doc_ley_1581_propietario",
    label: "Formato Ley 1581 de 2013 — autorización datos (propietario del proyecto)",
    item: 2,
  },
  {
    tipo: "gestion_doc_ley_1581_contratista",
    label: "Formato Ley 1581 de 2013 — autorización datos (contratista obra eléctrica)",
    item: 2,
  },
  {
    tipo: "gestion_doc_cedula_representante_legal",
    label: "Cédula del representante legal del dueño del proyecto",
    item: 4,
  },
  {
    tipo: "gestion_doc_matricula_cedula_ingeniero",
    label: "Matrícula profesional y cédula del ingeniero diseñador del proyecto",
    item: 5,
  },
  {
    tipo: "gestion_doc_presupuesto_electrico",
    label: "Presupuesto eléctrico valorizado y mano de obra",
    item: 6,
  },
  {
    tipo: "gestion_doc_diagrama_unifilar",
    label: "Diagrama unifilar (trayectoria acometida, cámaras, medidor, carga kVA)",
    item: 7,
  },
  {
    tipo: "gestion_doc_carta_autorizacion",
    label: "Carta de autorización del propietario al ingeniero/contratista para trámites de diseño",
    item: 8,
  },
  {
    tipo: "gestion_doc_solicitud_creg_e1",
    label: "Solicitud de Servicio Público de Energía — Formato CREG E1",
    item: 9,
  },
  {
    tipo: "gestion_doc_camara_comercio",
    label: "Cámara de comercio",
    item: 10,
  },
  {
    tipo: "gestion_doc_autodeclaracion_retie",
    label: "Autodeclaración de cumplimiento RETIE",
    item: 11,
  },
  {
    tipo: "gestion_doc_rut",
    label: "RUT",
    item: 12,
  },
  {
    tipo: "gestion_doc_permisos_licencias",
    label: "Permisos de construcción, licencias urbanísticas y anexos",
    item: 13,
  },
  {
    tipo: "gestion_doc_certificado_tradicion",
    label: "Certificado de tradición",
    item: 14,
  },
  {
    tipo: "gestion_doc_declaracion_cumplimiento_disenada",
    label: "Declaración de cumplimiento diseñada",
    item: 15,
  },
] as const;

export const TIPOS_DOC_GESTION_DOCUMENTAL = GESTION_DOCUMENTAL_ITEMS.map((i) => i.tipo);

export function esTipoGestionDocumental(tipo: string): boolean {
  const safe = String(tipo || "")
    .replace(/[^a-z0-9_]/gi, "")
    .toLowerCase();
  return TIPOS_DOC_GESTION_DOCUMENTAL.includes(safe as (typeof TIPOS_DOC_GESTION_DOCUMENTAL)[number]);
}
